var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Bewerbung als")]),_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.job ? _vm.job : _vm.$store.state.job))]),_c('div',{staticClass:"line"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }